import React, { useEffect, useState } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import $ from "jquery"
export default function CreateInterview() {

    useEffect(() => {

    }, []);
    const [menuClick, setMenuClick] = useState(false)
    const toggleMenu = () => {
        setMenuClick(!menuClick)
    }
    const closeMenu = () => {
        setMenuClick(false)
    }
    return (
        <>
            <div className="main-wrapper">
                <div className="top-color"></div>
                <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
                <div className="content-wrapper">
                    <Header Header="Create Interview" toggleMenu={toggleMenu} menuClick={menuClick} />
                    <div className="main-container">

                        <div className="row">
                            <div className="card main-card">
                                <div className="card-body">
                                    <h1 className="sub-head">Interview Information</h1>
                                    <div className="row mb-3">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Interview Name : </label>
                                            <select className="form-control">
                                                <option value="">Select</option>
                                                <option value="">Online Interview</option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Department Name : </label>
                                            <select className="form-control">
                                                <option value="">Select</option>
                                                <option value="">Online Interview</option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">From : </label>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <DatePicker
                                                        selected={new Date()}
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        placeholderText="Select date "
                                                    //   minDate={new Date()}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <DatePicker
                                                        selected={new Date()}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        //   timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        className="form-control  interTime"
                                                        placeholderText="Select time"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">To : </label>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <DatePicker
                                                        selected={new Date()}
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        placeholderText="To"
                                                    //   minDate={new Date()}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <DatePicker
                                                        selected={new Date()}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        //   timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        className="form-control interTime "
                                                        placeholderText="Select time"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Interviewer(s) : </label>
                                            <select className="form-control">
                                                <option value="">Select</option>
                                                <option value="">Online Interview</option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Location : </label>
                                            <input type="text" className="form-control" placeholder="Enter Location" />
                                        </div>
                                    </div>
                                    <h1 className="sub-head">Candidate Information</h1>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Candidate Name : </label>
                                            <input type="text" className="form-control" placeholder="Enter Candidate Name" />

                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Posting Title : </label>
                                            <input type="text" className="form-control" placeholder="Enter Posting Title" />

                                        </div>

                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Interview Owner : </label>
                                            <select className="form-control">
                                                <option value="">Select</option>
                                                <option value="">John</option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="" className="form-label">Comments : </label>
                                            <textarea type="text" className="form-control" placeholder="Enter Comments" />
                                        </div>


                                    </div>
                                    {/* <div className="col-md-6">
                                        
                                            <h1 className="sub-head">Resume Information</h1>
                                            
                                        
                                    </div> */}
                                    <div className="col-md-12 text-end">
                                        <button type="button" className="btn btn-btn2 btn-btn">Next</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}